import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	resultsAnnouncement: {
		id: 'software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.results-announcer.results-announcement',
		defaultMessage:
			'{count, plural, =0 {no results found} one {one result found} other {# results found}}',
		description: 'Screenreader message to annouince the number of search results found',
	},
	loading: {
		id: 'software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.results-announcer.loading',
		defaultMessage: 'Loading results',
		description: 'Screenreader message announced when search results are loading',
	},
});
